/**
 * Dynamoには保管しないメモリ上のEntity
 */
export enum EntityNamePvt {
  /** こども親 */
  WagakoAppChildParentEntity = 'WagakoAppChild_ParentEntity',
  /** こどもクラス */
  WagakoAppChildClassEntity = 'WagakoAppChild_ClassEntity',
  /** こども施設 */
  WagakoAppChildFacilityEntity = 'WagakoAppChild_FacilityEntity',
  /** お知らせコンテンツ */
  WagakoAppNewsContentEntity = 'WagakoAppNews_ContentEntity',
  /** 測定 */
  WagakoAppMeasureChildEntity = 'WagakoAppMeasure_ChildEntity',
  /** 登園記録 */
  WagakoNurseryAttendContactChildEntity = 'WagakoNurseryAttendContact_ChildEntity',
  /** 申請こども */
  WagakoNurseryChildApplyChildEntity = 'WagakoNurseryChildApply_ChildEntity',
  /** 申請親 */
  WagakoNurseryChildApplyParentEntity = 'WagakoNurseryChildApply_ParentEntity',
  /** 掲示板コンテンツ */
  WagakoAppNoticeContentEntity = 'WagakoAppNotice_ContentEntity',
  /** 写真 */
  WagakoNurseryPhotoPhotoAppEntity = 'WagakoNurseryPhoto_PhotoAppEntity',
  /** ホームページコンテンツ */
  WagakoNurseryHomepageContentEntity = 'WagakoNurseryHomepage_ContentEntity',
  /** 園内ブログコンテンツ */
  WagakoNurseryPrivateBlogContentEntity = 'WagakoNurseryPrivateBlog_ContentEntity',
  /** デバイス情報 */
  WagakoNurseryDeviceDeviceInfoEntity = 'WagakoNurseryDevice_DeviceInfoEntity'
}
